import { Link, Navigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeadset,
  faShoppingCart,
  faMagnifyingGlass,
  faArrowRight,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { useEffect, useState } from "react";
import axios from "axios";

export default function Header({
  user,
  handleAuth,
  cartItemsCount,
  searchedProducts,
  setSearchedProducts,
}) {
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchBtnToggle, setSearchBtnToggle] = useState(false);
  const [dropdownToggle, setDropdownToggle] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);
  const search = new URLSearchParams(location.search).get("search");

  const handleSearch = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_LINK}/getsearchproducts?search=${searchInput}`
      )
      .then((res) => {
        // console.log(res.data);
        setSearchedProducts(res.data);
        setShowSearchResults(true);
        // Setting timer to true after 1 sec so that the showSearchResults gets false and does not re navigate to search results
        setTimeout(() => {
          setShowSearchResults(false);
          setSearchInput("");
        }, 1000);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (search !== null) {
      setSearchInput(search);
      handleSearch();
    }
  }, []);

  const handleSearchWrapper = (e) => {
    e.preventDefault();
    handleSearch();
  };

  return (
    <nav
      className={
        location.pathname === "/" || location.pathname === "/store"
          ? "px-7 md:px-52 sticky top-0 z-50 py-5 md:mb-0 flex justify-between bg-white"
          : "px-7 md:px-52 sticky top-0 z-50 py-5 flex justify-between bg-white border-b-2 border-ambhosOrange"
      }
    >
      {showSearchResults && (
        <Navigate to={`/store/products?search=${searchInput}`} />
      )}
      {/* brand name */}
      <Link
        to="/"
        className={`${searchBtnToggle ? "hidden" : "flex"} items-center`}
      >
        <div className="align-middle w-32 md:w-44 mr-5">
          <h1 className="text-3xl font-bold text-ambhosOrange">Brio<span className="text-gray-400">Cart</span></h1>
          {/* <img
            src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/ambhos_full_logo.png"
            className=""
            alt="Ambhos"
          /> */}
        </div>
      </Link>

      {/* Search option */}
      <form onSubmit={handleSearchWrapper}>
        <div
          className={`lg:flex border-2 border-gray-300 rounded-lg justify-center items-center align-middle ${
            searchBtnToggle ? "flex w-full" : "hidden"
          }`}
        >
          <FontAwesomeIcon
            className="px-2 py-3 text-gray-400"
            icon={faMagnifyingGlass}
          />
          <input
            type="text"
            placeholder="Search for products"
            className="w-52 md:w-96 focus:outline-none"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
          <button
            type="submit"
            className="px-2 text-gray-400 hover:text-ambhosOrange"
          >
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>
      </form>
      <div
        className={`${
          searchBtnToggle ? "flex" : "hidden"
        } justify-center items-center pl-3 text-lg text-gray-400`}
        onClick={() => setSearchBtnToggle(false)}
      >
        <FontAwesomeIcon icon={faXmark} />
      </div>

      {/* Nav Menu Items */}
      <div className="flex justify-center items-center">
        {/* Mobile View Options */}
        <div className="flex space-x-2 md:space-x-1 md:mt-1">
          <div
            className={`${
              searchBtnToggle ? "hidden" : "flex"
            } lg:hidden text-xl`}
            onClick={() => setSearchBtnToggle(true)}
          >
            <FontAwesomeIcon
              className="px-1 py-3 text-gray-400"
              icon={faMagnifyingGlass}
            />
          </div>

          {user ? (
            <div className={searchBtnToggle ? "hidden" : "mt-1.5 md:mt-0"}>
              <p
                onMouseOver={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
                className="md:pl-5 px-1 text-2xl text-ambhosOrange cursor-pointer"
              >
                <FontAwesomeIcon className="" icon={faUserCircle} />
              </p>
              <div
                onMouseOver={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
                className={
                  showDropdown
                    ? "absolute bg-white text-gray-700 rounded-lg border px-5 text-lg z-50"
                    : "absolute bg-white text-gray-700 rounded-lg border px-5 text-lg hidden"
                }
              >
                <Link to="/profile">
                  <p
                    onClick={() => setShowDropdown(false)}
                    className="my-3 cursor-pointer"
                  >
                    Profile
                  </p>
                </Link>
                <Link to="/orderhistory">
                  <p
                    onClick={() => setShowDropdown(false)}
                    className="my-3 cursor-pointer"
                  >
                    Orders
                  </p>
                </Link>
                <p className="my-3 cursor-pointer" onClick={handleAuth}>
                  Log Out
                </p>
              </div>
            </div>
          ) : (
            <Link to="/signIn" className="">
              <p
                className={
                  location.pathname === "/signIn"
                    ? "hidden lg:block pl-5 pr-1 text-lg text-ambhosOrange"
                    : "hidden lg:block pl-5 pr-1 text-lg"
                }
              >
                Sign In
              </p>
            </Link>
          )}
          <Link
            to="/contact"
            className="hidden lg:flex justify-center items-center"
          >
            <p className="pl-5 pr-1 text-2xl text-ambhosOrange">
              <FontAwesomeIcon className="" icon={faHeadset} />
            </p>
          </Link>

          <Link
            to="/cart"
            className={
              searchBtnToggle ? "hidden" : "flex justify-center items-center"
            }
          >
            <p className="relative md:pl-5 px-1 text-2xl text-ambhosOrange cursor-pointer">
              <FontAwesomeIcon className="" icon={faShoppingCart} />
              <span className="absolute -top-2 -right-2 inline-flex items-center justify-center h-5 w-5 rounded-full bg-gray-500 text-white text-xs">
                {cartItemsCount}
              </span>
            </p>
          </Link>

          <div
            className={`${searchBtnToggle ? "hidden" : ""} relative lg:hidden`}
          >
            <button
              onMouseOver={() => setDropdownToggle(true)}
              onMouseLeave={() => setDropdownToggle(false)}
              className="flex justify-center items-center mt-1.5"
            >
              <p className="pl-3 pr-1 text-2xl text-gray-400">
                <FontAwesomeIcon icon={faBars} />
              </p>
            </button>

            <div
              onMouseOver={() => setDropdownToggle(true)}
              onMouseLeave={() => setDropdownToggle(false)}
              className={
                dropdownToggle
                  ? "absolute right-0 mt-2 w-56 bg-white rounded-lg border p-5 text-lg z-50"
                  : "absolute right-0 mt-2 w-56 bg-white rounded-lg border p-5 text-lg hidden"
              }
              // className="absolute z-10 right-0 mt-2 w-56 bg-gray-100 rounded-lg shadow-lg"
            >
              <div
                className="py-1"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                {!user && (
                  <Link to="/signIn">
                    <p
                      onClick={() => setDropdownToggle(false)}
                      className={
                        location.pathname === "/signIn"
                          ? "block px-4 py-2 text-md text-ambhosOrange"
                          : "px-4 py-2 text-md text-gray-700"
                      }
                    >
                      Sign In
                    </p>
                  </Link>
                )}
                <Link to="/contact" className="flex items-center">
                  <p
                    onClick={() => setDropdownToggle(false)}
                    className={
                      location.pathname === "/contact"
                        ? "block px-4 py-2 text-md text-ambhosOrange"
                        : "px-4 py-2 text-md text-gray-700"
                    }
                  >
                    Customer Support
                  </p>
                  {/* <FontAwesomeIcon className="" icon={faHeadset} /> */}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
